import React from 'react';
import PropTypes from 'prop-types';
import NotableCharacterDetails from './NotableCharacterDetails';

const NotableCharacter = props => {
  return (
    <div id="profile-container">
      <div className="card main-card">
        <div className="card-header header-card">NOTABLE CHARACTERISTICS</div>
        <div className="row expanded card-section">
          <div className="row fullwidth demographic-detail-columns" id="notablePersonaGrid">
            <div>
              {props.segments && props.segments.length > 0 &&
                props.segments.map((segment, index) => (
                  <div key={index}>
                    <div
                      className="columns large-4 medium-4 small-4 demographic-detail-columns"
                      id="profileTopBrandsBorder"
                    >
                      {segment.clusterStatements && segment.clusterStatements.length > 0 &&
                        segment.clusterStatements.map((statement, i) => (
                          <div
                            className="row fullwidth demographic-detail-columns"
                            key={`prof-t-m${index + i}`}
                          >
                            <div
                              className="columns large-12 small-12 medium-12 demographic-detail-columns"
                              id="pdfNotablePersonaGridRowLen"
                            >
                              {
                                <NotableCharacterDetails
                                  key={i}
                                  statement={statement}
                                />
                              }
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          {props.sourceDataInfo()}
          <div id={props.endId} />
        </div>
      </div>
    </div>

  );
};

NotableCharacter.propTypes = {
  segments: PropTypes.instanceOf(Array),
  sourceDataInfo: PropTypes.string,
  endId: PropTypes.string,
};

export default NotableCharacter;
